/* eslint-disable react/no-unescaped-entities */
import React from "react";
import LegalLayout, { H2, H3, P, Ul } from "./LegalLayout";
import Seo from "../Seo";

const CONTROLLER_EMAIL = "privacy@mydigitalaction.it";
const CONTROLLER_ADDRESS = "Via San Franceschino 69/D, 55047 Seravezza (LU), Italia";
const CONTROLLER_VAT = "02124640461";

export default function TerminiCondizioniPage() {
  return (
    <LegalLayout title="Termini e Condizioni" kicker="Contratto di vendita a distanza" lastUpdated="Febbraio 2026">
      <Seo title="Termini e Condizioni — MyDigitalAction" description="Termini e condizioni di vendita a distanza dei corsi MyDigitalAction." path="/termini-condizioni" />
      <P>
        I presenti Termini e Condizioni disciplinano l'acquisto dei corsi e dei servizi offerti tramite il sito{" "}
        <strong className="text-white">mydigitalaction.it</strong>{" "}
        (di seguito &laquo;Sito&raquo;), gestito da <strong className="text-white">Digital Formula di Francesco Gherardi</strong> (P.IVA {CONTROLLER_VAT}), con sede legale in{" "}
        {CONTROLLER_ADDRESS}, email <a href={`mailto:${CONTROLLER_EMAIL}`} style={{ color: "#d4ff3d" }}>{CONTROLLER_EMAIL}</a> (di seguito &laquo;Titolare&raquo; o &laquo;Venditore&raquo;).
      </P>

      <H2>1. Definizioni</H2>
      <Ul>
        <li><strong className="text-white/90">Cliente</strong>: persona fisica o giuridica che acquista un corso o un servizio tramite il Sito.</li>
        <li><strong className="text-white/90">Prodotto</strong>: corso di formazione (in aula o online) e relativi bonus, materiali didattici e servizi accessori descritti sul Sito.</li>
        <li><strong className="text-white/90">Ordine</strong>: proposta contrattuale inviata dal Cliente tramite il Sito.</li>
        <li><strong className="text-white/90">Contratto</strong>: accordo perfezionato tra Venditore e Cliente al momento dell'accettazione dell'Ordine e del pagamento.</li>
      </Ul>

      <H2>2. Oggetto e conclusione del contratto</H2>
      <P>
        Il Sito offre corsi di formazione professionale in ambito marketing digitale, comunicazione, intelligenza
        artificiale applicata al business e affini. I Prodotti sono descritti sulle relative pagine con indicazione di
        contenuti, durata, prezzo e modalit&agrave; di erogazione.
      </P>
      <P>
        Il Contratto si perfeziona nel momento in cui il Cliente completa il processo di pagamento tramite il checkout
        del Sito (integrato con Stripe) e riceve l'email di conferma d'ordine all'indirizzo indicato.
      </P>

      <H2>3. Prezzi e pagamento</H2>
      <P>
        Tutti i prezzi indicati sul Sito sono espressi in Euro (EUR) e sono IVA inclusa, salvo diversa e specifica indicazione.
        I metodi di pagamento accettati sono:
      </P>
      <Ul>
        <li>Carta di credito / debito (Visa, Mastercard, American Express) &mdash; via Stripe.</li>
        <li>PayPal &mdash; via Stripe.</li>
        <li>Altri metodi elettronici disponibili tramite Stripe Checkout (Apple Pay, Google Pay, Link, ecc.) in base al Paese e al dispositivo del Cliente.</li>
      </Ul>
      <P>
        Il pagamento &egrave; elaborato in maniera sicura da Stripe. Il Venditore non ha accesso ai dati completi della carta
        di credito, che vengono trattati direttamente dal circuito di pagamento in conformit&agrave; agli standard PCI-DSS.
      </P>

      <H2>4. Fatturazione</H2>
      <P>
        La fattura elettronica &egrave; emessa dal Venditore per ogni ordine ricevuto. Il Cliente pu&ograve; richiedere
        l'invio della fattura a un indirizzo email diverso o l'inserimento di dati di fatturazione specifici (partita IVA,
        codice destinatario SDI) contattando il Venditore all'indirizzo email indicato in premessa entro 7 giorni dall'acquisto.
      </P>

      <H2>5. Erogazione del corso</H2>
      <H3>5.1 Corsi in aula</H3>
      <P>
        Il Cliente riceve, tramite email, le informazioni logistiche (data, orario, luogo) del corso in aula acquistato.
        La partecipazione &egrave; nominativa e non trasferibile a terzi senza previo consenso scritto del Venditore.
      </P>
      <H3>5.2 Corsi e materiali online</H3>
      <P>
        L'accesso ai contenuti online, ove previsti, viene fornito tramite email di conferma con eventuali credenziali di
        accesso o link ai materiali didattici. L'accesso &egrave; personale e non trasferibile.
      </P>

      <H2>6. Diritto di recesso</H2>
      <P>
        Ai sensi degli artt. 52 e ss. del Codice del Consumo (D.Lgs. 206/2005), il Cliente consumatore ha diritto di
        recedere dal Contratto entro 14 giorni dalla data di conclusione dello stesso, senza necessit&agrave; di
        motivazione e senza penali.
      </P>
      <P>
        Per esercitare il diritto di recesso, il Cliente deve inviare una comunicazione scritta all'indirizzo email{" "}
        <a href={`mailto:${CONTROLLER_EMAIL}`} style={{ color: "#d4ff3d" }}>{CONTROLLER_EMAIL}</a> entro il termine sopra indicato.
      </P>
      <P>
        Il Venditore garantisce inoltre una <strong className="text-white/90">"soddisfatti o rimborsati" di 14 giorni</strong>{" "}
        dalla data di acquisto: se il Cliente non &egrave; soddisfatto del corso pu&ograve; richiedere il rimborso integrale
        entro tale termine, scrivendo al Venditore.
      </P>
      <H3>Limitazioni al diritto di recesso</H3>
      <P>
        Ai sensi dell'art. 59, comma 1, lettera o) del Codice del Consumo, il diritto di recesso &egrave; escluso una volta
        iniziata l'erogazione di contenuti digitali (es. accesso ai materiali online) se il Cliente ha espressamente accettato
        di iniziare l'esecuzione e ha riconosciuto di aver perso il diritto di recesso al momento dell'inizio dell'esecuzione.
      </P>

      <H2>7. Rimborso</H2>
      <P>
        In caso di recesso o richiesta di rimborso, il Venditore rimborsa il Cliente entro 14 giorni dalla ricezione della
        comunicazione utilizzando lo stesso metodo di pagamento usato per l'acquisto (via Stripe), salvo diverso accordo.
      </P>

      <H2>8. Propriet&agrave; intellettuale</H2>
      <P>
        Tutti i contenuti dei corsi (video, dispense, testi, immagini, esercizi, template) sono di propriet&agrave;
        esclusiva del Venditore o dei formatori incaricati e sono protetti dalle leggi italiane e internazionali sul diritto d'autore.
      </P>
      <P>
        Al Cliente &egrave; concessa una licenza personale, non esclusiva e non trasferibile per l'uso dei contenuti a soli
        fini formativi personali. &Egrave; vietata qualsiasi forma di riproduzione, distribuzione, condivisione pubblica,
        modifica o utilizzo commerciale senza previo consenso scritto del Venditore.
      </P>

      <H2>9. Responsabilit&agrave;</H2>
      <P>
        Il Venditore non pu&ograve; garantire risultati economici o professionali specifici derivanti dalla fruizione dei
        corsi, in quanto il successo dipende dall'impegno personale del Cliente e da fattori esterni. I corsi sono strumenti
        di formazione e non costituiscono consulenza legale, fiscale o finanziaria.
      </P>
      <P>
        Il Venditore non risponde per interruzioni del servizio dovute a cause di forza maggiore, guasti tecnici di terzi
        (hosting, CDN, provider di pagamento) o eventi al di fuori del suo ragionevole controllo.
      </P>

      <H2>10. Trattamento dei dati personali</H2>
      <P>
        Le modalit&agrave; di trattamento dei Dati Personali del Cliente sono descritte nella{" "}
        <a href="/privacy-policy" style={{ color: "#d4ff3d" }}>Privacy Policy</a> del Sito, che costituisce parte integrante dei presenti Termini.
      </P>

      <H2>11. Legge applicabile e foro competente</H2>
      <P>
        I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia inerente all'interpretazione,
        esecuzione o validit&agrave; degli stessi &egrave; competente in via esclusiva il Foro del luogo di residenza o
        domicilio del Cliente consumatore, ove ubicato in Italia. Per Clienti non consumatori il foro competente &egrave;
        quello di Pisa.
      </P>

      <H2>12. Risoluzione delle controversie (ODR)</H2>
      <P>
        Ai sensi del Regolamento (UE) 524/2013, il Cliente consumatore pu&ograve; presentare eventuali reclami tramite la
        piattaforma europea di risoluzione delle controversie online (ODR), accessibile al seguente link:{" "}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer noopener" style={{ color: "#d4ff3d" }}>
          https://ec.europa.eu/consumers/odr
        </a>.
      </P>

      <H2>13. Modifiche</H2>
      <P>
        Il Venditore si riserva il diritto di modificare i presenti Termini in qualsiasi momento. Le modifiche saranno
        pubblicate sul Sito e si applicheranno agli ordini effettuati dopo la data della loro pubblicazione.
      </P>

      <H2>14. Contatti</H2>
      <P>
        Digital Formula di Francesco Gherardi &mdash; MyDigitalAction Experience<br />
        Sede legale: {CONTROLLER_ADDRESS}<br />
        Partita IVA: {CONTROLLER_VAT}<br />
        Email: <a href={`mailto:${CONTROLLER_EMAIL}`} style={{ color: "#d4ff3d" }}>{CONTROLLER_EMAIL}</a><br />
        WhatsApp: +39 320 445 9052
      </P>
    </LegalLayout>
  );
}
